<div class="review-csv-upload">
  <div class="upload-file-header">
    <span class="upload-file-label">Upload File</span>
    <pdq-button
      variant="transparent-info"
      size="small"
      icon="download"
      iconColor="var(--on-surface-default)"
      label="Download Template"
      labelColor="var(--on-surface-default)"
      [fitContent]="true"
      (click)="downloadTemplate()">
    </pdq-button>
  </div>

  @if (!hasFile && !uploadError) {
    <div
      class="upload-area"
      [class.drag-over]="isDragOver"
      (dragover)="onDragOver($event)"
      (dragleave)="onDragLeave($event)"
      (drop)="onDrop($event)">
      <label class="upload-label">
        <input type="file" accept=".csv" (change)="onFileSelected($event)" hidden />
        <div class="upload-text">
          <span class="primary-text">Drop your CSV file here</span>
          <span class="secondary-text">or click to browse</span>
        </div>
      </label>
    </div>
  }

  @if (uploadError) {
    <div class="error-state">
      <div class="error-content">
        <span class="error-title">Upload failed.</span>
        <span class="error-message">{{ uploadError }}</span>
        <span class="error-helper">Please check your file and try again.</span>
      </div>
      <div class="error-actions">
        <button class="error-btn" (click)="retryUpload()">Try Again</button>
      </div>
    </div>
  }

  @if (hasFile && !uploadError) {
    <div class="file-info">
      <div class="file-toolbar">
        <div class="file-details">
          <div class="file-meta">
            <span class="file-name">{{ fileName }}</span>
            <span class="file-stats">{{ formatFileSize(fileSize) }}</span>
          </div>
        </div>
        <div class="file-actions">
          <button class="download-btn" (click)="downloadCurrentFile()">
            <pdq-icon icon="download" size="small"></pdq-icon>
          </button>
          <button class="replace-btn" (click)="replaceFile()">
            <pdq-icon icon="change" size="small"></pdq-icon>
            <span>Replace File</span>
          </button>
          <button class="remove-btn" (click)="removeFile()">
            <pdq-icon icon="close" size="small"></pdq-icon>
          </button>
        </div>
      </div>
    </div>
  }

  <pdq-banner
    variant="attention"
    [closable]="false"
    bannerTitle="Notice"
    content="Your CSV must contain only 1 review per product ID"></pdq-banner>
</div>
